
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { 
  Rocket, 
  GraduationCap, 
  Megaphone, 
  Shield,
  Settings
} from 'lucide-react';

interface KitNavigationProps {
  currentKit?: string;
}

const KitNavigation = ({ currentKit }: KitNavigationProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const kits = [
    { id: 'launch', label: 'Launch Kit', icon: Rocket, path: '/hq/kits/launch' },
    { id: 'training', label: 'Training Kit', icon: GraduationCap, path: '/hq/kits/training' },
    { id: 'marketing', label: 'Marketing Kit', icon: Megaphone, path: '/hq/kits/marketing' },
    { id: 'compliance', label: 'Compliance Kit', icon: Shield, path: '/hq/kits/compliance' },
    { id: 'technology', label: 'Technology Kit', icon: Settings, path: '/hq/kits/technology' }
  ];

  const isActive = (kitId: string) => {
    return location.pathname.includes(kitId) || currentKit === kitId;
  };

  return (
    <div className="bg-slate-800/30 backdrop-blur border-b border-slate-600/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-1 py-4 overflow-x-auto">
          {kits.map((kit) => {
            const IconComponent = kit.icon;
            const active = isActive(kit.id);
            
            return (
              <Button
                key={kit.id}
                variant={active ? "default" : "ghost"}
                className={`flex items-center space-x-2 whitespace-nowrap ${
                  active 
                    ? 'bg-amber-600 hover:bg-amber-700 text-white' 
                    : 'text-slate-300 hover:text-white hover:bg-slate-700/50'
                }`}
                onClick={() => navigate(kit.path)}
              >
                <IconComponent className="h-4 w-4" />
                <span>{kit.label}</span>
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default KitNavigation;
